import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import bm from './locales/bm.json';

const STORAGE_KEY = 'hln_lang';

function detectInitialLang() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'en' || stored === 'bm') return stored;
  } catch { /* ignore */ }
  return 'bm'; // Default: Bahasa Malaysia (Malaysian audience)
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      bm: { translation: bm },
    },
    lng: detectInitialLang(),
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

// Persist language changes automatically
i18n.on('languageChanged', (lng) => {
  try { localStorage.setItem(STORAGE_KEY, lng); } catch { /* ignore */ }
});

export default i18n;
